import React from 'react'
import styles from '../css/DemotionReason.module.css'
import Icon from '../../Icon/Icon'

function AddNewReason(props) {
    return (
        <div className={[styles.wrapper, styles.addNew].join(" ")} onClick={() => {
            props.addReason()
        }}>
            <Icon name="plus" className={styles.plus} />
            <div>Add New Reason</div>
        </div>
    )
}

export default AddNewReason
